import dynamic from 'next/dynamic';

import { useDevice } from '@contexts/device';
import { HotelDetailVideoViewModel, TourMediaDataViewModel } from '@api/v3';

const DesktopVideoItem = dynamic(() => import('./DesktopGalleryVideoItem'));
const MobileVideoItem = dynamic(() => import('./MobileGalleryVideoItem'));

export type HotelGalleryVideoItem = TourMediaDataViewModel & {
  fallBackImage?: string;
};

type Props = {
  item: HotelGalleryVideoItem | HotelDetailVideoViewModel;
  isFullScreen?: boolean;
  gallery?: boolean;
  video: HotelDetailVideoViewModel;
};

const VideoGalleryItem = ({ item, isFullScreen, gallery, video }: Props) => {
  const { isDesktop } = useDevice();
  return isDesktop ? (
    <DesktopVideoItem item={item} isFullScreen={isFullScreen} />
  ) : (
    <MobileVideoItem video={video} gallery={gallery} item={item} />
  );
};

export default VideoGalleryItem;
